import {
	BarChartOutlined,
	CommentOutlined,
	LogoutOutlined,
	SettingOutlined,
	TeamOutlined,
} from "@ant-design/icons";
import { useLogout } from "@refinedev/core";
import { Layout, Menu } from "antd";
import { Link, useLocation } from "react-router";
import {
	ADMIN_SIDER_COLLAPSED_WIDTH,
	ADMIN_SIDER_WIDTH,
	tamsThemeColors,
} from "../theme";

const NAV_ITEMS = [
	{
		key: "/users",
		icon: <TeamOutlined />,
		label: <Link to="/users">ユーザー管理</Link>,
	},
	{
		key: "/posts",
		icon: <CommentOutlined />,
		label: <Link to="/posts">公式お知らせ管理</Link>,
	},
	{
		key: "/reports",
		icon: <BarChartOutlined />,
		label: <Link to="/reports">統計・レポート</Link>,
	},
	{
		key: "/staff",
		icon: <SettingOutlined />,
		label: <Link to="/staff">スタッフ管理</Link>,
		adminOnly: true,
	},
] as const;

type AdminSiderProps = {
	collapsed: boolean;
	canManageStaff: boolean;
};

export function AdminSider({ collapsed, canManageStaff }: AdminSiderProps) {
	const location = useLocation();
	const { mutate: logout, isPending } = useLogout();

	const selectedKey = NAV_ITEMS.map((item) => item.key).find((key) =>
		location.pathname.startsWith(key),
	);

	const items = NAV_ITEMS.filter(
		(item) => !("adminOnly" in item && item.adminOnly) || canManageStaff,
	).map(({ key, icon, label }) => ({ key, icon, label }));

	const confirmLogout = () => {
		if (window.confirm("ログアウトしますか？")) {
			logout();
		}
	};

	return (
		<Layout.Sider
			className="admin-sider"
			collapsible
			collapsed={collapsed}
			trigger={null}
			width={ADMIN_SIDER_WIDTH}
			collapsedWidth={ADMIN_SIDER_COLLAPSED_WIDTH}
			style={{
				overflow: "auto",
				height: "100vh",
				position: "fixed",
				insetInlineStart: 0,
				top: 0,
				bottom: 0,
			}}
		>
			<Link
				to="/users"
				className="admin-sider-brand"
				style={{
					justifyContent: collapsed ? "center" : "flex-start",
					paddingInline: collapsed ? 12 : 20,
				}}
			>
				<img
					src="/app-icon.png"
					alt=""
					width={32}
					height={32}
					style={{ borderRadius: 8, display: "block", flexShrink: 0 }}
				/>
				{!collapsed ? (
					<span className="admin-sider-brand-text">
						<span className="admin-sider-brand-title">たむたむ広場</span>
						<span className="admin-sider-brand-sub">管理画面</span>
					</span>
				) : null}
			</Link>

			<Menu
				className="admin-sider-menu"
				mode="inline"
				inlineCollapsed={collapsed}
				selectedKeys={selectedKey ? [selectedKey] : []}
				items={items}
			/>

			<div className="admin-sider-footer">
				<button
					type="button"
					className="admin-sider-logout"
					disabled={isPending}
					onClick={confirmLogout}
					title="ログアウト"
				>
					<LogoutOutlined
						style={{ fontSize: 16, color: tamsThemeColors.foreground }}
					/>
					{!collapsed ? <span>ログアウト</span> : null}
				</button>
			</div>
		</Layout.Sider>
	);
}
